// ── Colors & App Data ───────────────────────────────────────────────────
export interface AppDataEntry {
  name: string;
  cover?: string;
  edgeColor?: string;
  appId?: string;
  kind?: 'installer' | 'activity' | 'placeholder';
  projectId?: string;
  sessionInstalled?: boolean;
  installState?: string;
  organismScaleBoost?: number;
}

export const COLORS = ['#00ED95', '#6489F4', '#FF3A5E', '#8D51CB', '#1C1D9C', '#87DDFE', '#82584A'] as const;

// 20 apps total. Rings fill inner-first, so slots 0-11 populate the inner
// ring completely and slots 12-19 partially fill the middle ring. Adding a
// new app (e.g. via the installer) would continue filling middle → outer.
// All 10 real apps are kept; the 16 dropped entries were placeholder-only
// filler for the previous 36-slot layout.
export const APP_DATA: readonly AppDataEntry[] = [
  // ── Inner ring (slots 0-11, full at 12) ──
  { name: 'dice' },
  { name: 'flashlight',      cover: 'covers/Flashlight.png',      edgeColor: '#1a1a1a', appId: 'https://onljswkegixyjjhpcldn.supabase.co/functions/v1/get-manifest?id=b7d9f6af-ad4f-4929-89fe-75a4c627495d&format=json' },
  { name: 'gallery' },
  { name: 'stamp',           cover: 'covers/Stamp.png',           edgeColor: '#3a2a3a', appId: 'https://onljswkegixyjjhpcldn.supabase.co/functions/v1/get-manifest?id=927879b1-a42e-410c-9c9b-6b064a3e26ad&format=json' },
  { name: 'health' },
  { name: 'lumi',            cover: 'covers/Lumi-Cover.png',      edgeColor: '#0b0b0b', appId: 'lumi://launch' },
  { name: 'timer' },
  { name: 'celestial clock', cover: 'covers/Celestial-Clock.png', edgeColor: '#1a1408', appId: 'celestialclock://launch' },
  { name: 'games' },
  { name: 'videorama',       cover: 'covers/Videorama.png',       edgeColor: '#1a1a2a', appId: 'https://onljswkegixyjjhpcldn.supabase.co/functions/v1/get-manifest?id=2172822f-40a0-47c9-8675-dd406d546c2a&format=json' },
  { name: 'music' },
  { name: 'breakout',        cover: 'covers/Breakout-Cover.png',  edgeColor: '#d7cfbc', appId: 'breakout://launch' },
  // ── Middle ring (slots 12-19, 8 of 12 filled) ──
  { name: 'scan' },
  { name: 'vivarium',        cover: 'covers/Vivarium.png',        edgeColor: '#2a3a2a', appId: 'vivarium://launch' },
  { name: 'camera' },
  { name: 'bugs',            cover: 'covers/Bugs-Cover.png',      edgeColor: '#666666', appId: 'bugs://launch' },
  { name: 'settings' },
  { name: 'orbitone',        cover: 'covers/Orbitone.png',        edgeColor: '#0a0a0a', appId: 'https://onljswkegixyjjhpcldn.supabase.co/functions/v1/get-manifest?id=1ab20b73-cf63-4d4f-b442-3e6860b1bed2&format=json' },
  { name: 'add activity', kind: 'installer', edgeColor: '#6489F4' },
  { name: 'clock' },
] as const;
